module.exports = __webpack_public_path__ + "img/ICON_NFT_MARKET.15a9a658.png";